import styled from 'styled-components';

export const ButtonsWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  margin-top: ${props => props.marginTop};
  justify-content: flex-end;
`;
